var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column ma-1",style:(_vm.config.style),attrs:{"color":_vm.config.color,"elevation":"1","dark":""}},[_c('v-card-title',{staticClass:"text-h5",domProps:{"textContent":_vm._s(_vm.subtitle)}}),_c('v-spacer'),_c('v-card-actions',[_vm._t("actions")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }